import React from 'react';
import { Popover } from 'grab-ui';
import PropTypes from 'prop-types';
import css from './with-cashless-disabled-popover.less';

export const withCashlessPaymentDisabledPopover = ({
  child,
  message,
  buttonText,
  onRetry,
  placement,
}) => (
  <Popover
    content={
      <div>
        <p>{message}</p>
        {onRetry ? <button onClick={onRetry}>{buttonText}</button> : ''}
      </div>
    }
    trigger={'hover'}
    zIndex={10000}
    placement={placement}
    overlayClassName={css.cashlessDisabledPopover}
  >
    {child}
  </Popover>
);

withCashlessPaymentDisabledPopover.propTypes = {
  child: PropTypes.node.isRequired,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
  placement: PropTypes.string.isRequired,
};

export default {};
